export default {
    INIT: 'INIT',
    SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',
    UPDATE_NOTIFICATION: 'UPDATE_NOTIFICATION',
    ADD_FCM_NOTIFICATION: 'ADD_FCM_NOTIFICATION',
};
